@import (reference) '../../../constants/spacing.module.less';

.fraud-section-blocking {
  background-color: var(--red-100);
  border-radius: 4px;
  overflow: hidden;
}

.fraud-section-warning {
  background-color: var(--yellow-FFF6EB);
  margin-bottom: @space-16;
  border-radius: 4px;
  overflow: hidden;
}

.header-blocking,
.header-warning {
  align-items: center;

  svg {
    width: 16px;
    height: 16px;
  }
}

.header-blocking {
  color: var(--red-700);
}

.header-warning {
  color: var(--yellow-BD6E00);
}

.fraud-section-content {
  padding: @space-0 @space-16 @space-16;
}
